module.exports = __webpack_public_path__ + "static/media/woman.5efb873e.png";